import type { APPLICANT_ATTRIBUTION_BOTH_TYPE } from 'cpool-constants';

import type { LeafObject } from './compareArrayItems';
import { generateDiffItems } from './compareArrayItems';

interface Payload extends Partial<LeafObject> {
    id: string;
}

type RemovePayload = { id: string; gehoertZuAntragsteller: APPLICANT_ATTRIBUTION_BOTH_TYPE };

type CommandObject<TItemName extends string> =
    | { commandName: `add${TItemName}`; payload: LeafObject }
    | { commandName: `remove${TItemName}`; payload: RemovePayload }
    | {
          commandName: `change${TItemName}`;
          payload: Payload;
      };

export function generateArrayCommands<TItemName extends string>({
    itemName,
    newData,
    oldData,
}: {
    oldData: LeafObject[];
    newData: LeafObject[];
    itemName: TItemName;
}) {
    const differences = generateDiffItems(oldData, newData);
    const addCommands = differences.added.map<CommandObject<TItemName>>((payload) => ({
        commandName: `add${itemName}`,
        payload,
    }));
    const modifyCommands = differences.modified.map<CommandObject<TItemName>>((payload) => ({
        commandName: `change${itemName}`,
        payload,
    }));
    const removeCommands = differences.removed.map<{
        commandName: `remove${TItemName}`;
        payload: RemovePayload;
    }>((payload) => ({
        commandName: `remove${itemName}`,
        payload: {
            gehoertZuAntragsteller: payload.gehoertZuAntragsteller,
            id: payload.id,
        },
    }));
    return [...addCommands, ...modifyCommands, ...removeCommands];
}
